<template>
  <component :is="view" role="button" :class="classObject" @click="$emit('click')" :disabled="disabled">
    <slot />
  </component>
</template>

<script>
export default {
    name: 'Button',
    props: {
        type: {
            type: String,
            default: 'primary',
        },
        to: {
            type: [Object, String],
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        view() {
            if (this.to) {
                if (typeof this.to === 'object') {
                    return 'router-link';
                }
            }
            return 'a';
        },
        classObject() {
            return {
                'weui-btn': true,
                'weui-btn_primary': this.type === 'primary',
                'weui-btn_default': this.type === 'default',
                'weui-btn_warn': this.type === 'warn',
                'weui-btn_loading': this.loading,
                'weui-btn_disabled': this.disabled,
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/button/Index.vue